import React from 'react';
import publicSite from './publicSite';
import generatedEnglish from './locales/en.generated.json';

export const LANG_KEY = 'noesa.language.v1';
const LEGACY_LANG_KEY = 'ai_diary_lang';
export const SUPPORTED_LANGUAGES = ['ru', 'en'];

const ENGLISH_OVERRIDES = {
  'Расширенные лимиты': 'Extended allowance',
  'Примерно 7x лимитов Mini': 'About 7x the Mini allowance',
  'Год: 2 месяца бесплатно': 'Annual billing: 2 months free',
  'Mini стоит 149 ₽ в месяц, 745 ₽ за полгода или 1 490 ₽ за год: оплата при подключении, без пробного периода. В Plus, Pro и Max первое списание после пробного периода, если автопродление включено.': 'Mini costs ₽149/month, ₽745 for 6 months or ₽1,490/year, charged when you subscribe, with no trial. Plus, Pro and Max are charged after the trial if auto-renewal remains enabled.',
  'Улучшить свою жизнь': 'Improve my life',
  'Быстрее находить ответы и информацию': 'Find answers and information faster',
  'Эффективнее решать повседневные задачи': 'Handle everyday tasks more efficiently',
  'Развиваться в работе и учёбе': 'Grow in work and learning',
  'Сохранить историю своей жизни': 'Keep a record of my life',
  'Опишите свои цели, контекст и пожелания к ответам. До 1000 символов.': 'Describe your goals, context and response preferences. Up to 1000 characters.',
  'GPT-6 Astra и все модели GPT-5.6.': 'GPT-6 Astra and all GPT-5.6 models.',
  'Включая GPT-6 Astra': 'Including GPT-6 Astra',
  'Управление дневником, календарём и трекерами из чата': 'Manage diary, calendar, and trackers from chat',
  'От GPT-5.4 mini до GPT-5.6 Sol': 'GPT-5.4 mini through GPT-5.6 Sol',
  'GPT-6 Sol, Luna и GPT-5.4–5.6': 'GPT-6 Sol, Luna and GPT-5.4–5.6',
  'Изображения для AI-черновиков дневника': 'Images for AI diary drafts',
  'ИИ-планировщик календаря': 'AI calendar planner',
  'AI-обзоры': 'AI reviews',
  '5 / мес': '5 / mo',
  'В общем лимите ИИ': 'Uses your shared AI allowance',
  'В рамках лимита тарифа': 'Within your plan allowance',
  '3 бесплатные генерации / мес в рамках лимита тарифа': '3 free generations / month within your plan allowance',
  'До 10 МБ': 'Up to 10 MB',
  'До 25 МБ': 'Up to 25 MB',
  'До 50 МБ': 'Up to 50 MB',
  'До 100 МБ': 'Up to 100 MB',
  '1 пробный файл до 10 МБ на аккаунт': '1 trial file up to 10 MB per account',
  'Управление всей экосистемой из чатов': 'Manage the entire ecosystem from chats',
  '4 / мес': '4 / month',
  '50 / мес': '50 / mo',
  '200 / мес': '200 / mo',
  'Теневой аналитик и AI-черновики записей': 'Shadow analyst and AI entry drafts',
  'Сопряжение аккаунтов и сценарии для двоих': 'Account pairing and shared workflows',
  '5× лимитов Free': '5× the Free allowance',
  '12× лимитов Plus': '12× the Plus allowance',
  'Основная навигация': 'Main navigation',
  'Создать аккаунт бесплатно': 'Create a free account',
  'Войти': 'Sign in',
  'Вход': 'Sign in',
  'Выйти': 'Sign out',
  'Регистрация': 'Sign up',
  'Создать аккаунт': 'Create account',
  'Учетная запись': 'Account',
  'Внешний вид': 'Appearance',
  'Функции': 'Features',
  'Приложения': 'Apps',
  'Связь': 'Link',
  'Связи': 'Links',
  'Тема': 'Topic',
  'Инициативный друг': 'Proactive friend',
  'Инициативные сообщения': 'Proactive messages',
  'До 1 / неделю': 'Up to 1 / week',
  'До 2 / неделю': 'Up to 2 / week',
  'Адаптивная частота': 'Adaptive frequency',
  'Ассистент сможет иногда написать в Telegram или приложение: поддержать, вернуться к важному и предложить помощь. С 22:00 до 09:00 по вашему времени сообщения не отправляются. В push-уведомлении нет личных подробностей. Вы можете выключить инициативность в любой момент.': 'The assistant may occasionally message you in Telegram or the app to offer support, follow up on something important, or help. Messages are paused from 22:00 to 09:00 in your timezone. Push notifications contain no personal details. You can turn proactive messages off at any time.',
  'Для доставки подключите Telegram или разрешите уведомления в мобильном приложении.': 'Connect Telegram or allow notifications in the mobile app for delivery.',
  'Теневой аналитик': 'Shadow analyst',
  'Мозг': 'Brain',
  'Обновить': 'Refresh',
  'Обновления': 'Updates',
  'Подписка': 'Subscription',
  'Своё': 'Custom',
  'В момент': 'At event time',
  'Все': 'All',
  'Весь период': 'All time',
  'По настроению': 'Whenever I feel like it',
  'Маркетолог/Продакт': 'Marketing / Product',
  'Инженер/Программист': 'Engineer / Developer',
  'Не указывать': 'Prefer not to say',
  'Загрузка…': 'Loading…',
  'Пожалуйста, подождите пару секунд.': 'Please wait a moment.',
  'Не удалось загрузить данные': 'Could not load data',
  'Попробовать снова': 'Try again',
  'Подробнее': 'Learn more',
  'Далее': 'Continue',
  'Готово': 'Done',
  'Назад': 'Back',
  'Закрыть': 'Close',
  'Отмена': 'Cancel',
  'Сохранить': 'Save',
  'Удалить': 'Delete',
  'Редактировать': 'Edit',
  'Настройки': 'Settings',
  'Справка': 'Help',
  'Данные': 'Data',
  'Дневник': 'Diary',
  'Календарь': 'Calendar',
  'Трекер': 'Tracker',
  'Аналитика': 'Analytics',
  'Сегодня': 'Today',
  'Недавние': 'Recent',
  'Сообщение': 'Message',
  'Задачи': 'Tasks',
  'Пункт': 'Item',
  'Пункты': 'Items',
  'Фото': 'Photo',
  'Файл': 'File',
  'Камера': 'Camera',
  'Микрофон': 'Microphone',
  'Русский': 'Russian',
  'Светлая': 'Light',
  'Темная': 'Dark',
  'Авто': 'Automatic',
  'Язык интерфейса': 'Interface language',
  'Тарифы': 'Plans',
  'Посмотреть тарифы': 'View plans',
  'Цены': 'Plans & pricing',
  'Подробное сравнение тарифов noesa: возможности Free, Plus, Pro и Max, лимиты использования ИИ, модели, аналитика, файлы и условия пробного периода.': 'Compare noesa Free, Plus, Pro, and Max: AI usage allowances, models, analytics, file creation, and trial terms.',
  'Подробное сравнение тарифов noesa: модели, контекст, лимиты, мультимодальность, аналитика, граф знаний и сценарии, которые открываются на каждом уровне.': 'Detailed comparison of noesa plans: models, context windows, limits, multimodal features, analytics, the knowledge graph, and the workflows available at each level.',
  'Подробное сравнение тарифов': 'Detailed plan comparison',
  'Месяц': 'Month',
  'Полгода': '6 months',
  'Год': 'Year',
  'Старт без карты': 'Start without a card',
  'рекомендуем': 'Recommended',
  'База на каждый день': 'Everyday essentials',
  'Сильнее ИИ и аналитика': 'More capable AI and analytics',
  'Максимум возможностей': 'Full feature set',
  'Личная операционная система': 'Personal operating system',
  'Для активной личной системы: Auto сам выбирает подход, ищет свежую информацию и превращает разговоры в действия.': 'For an active personal system: Auto selects the right approach, searches for current information, and turns conversations into action.',
  'Для тех, кто хочет встроить noesa глубоко в жизнь: более сильный Auto, оформленные файлы, граф знаний и автоматизации.': 'For people who want noesa deeply integrated into daily life: a more capable Auto, polished files, a knowledge graph, and automations.',
  'Один аккаунт работает на сайте и в noesa Code; используется общий лимит выбранного тарифа.': 'One account works across the website and noesa Code, sharing the allowance of your selected plan.',
  'Сравните функции в разных тарифных планах': 'Compare features across plans',
  'Сверху — быстрый выбор тарифа, ниже — детали по ключевым возможностям. Всё в одном спокойном сравнении, без лишних акцентов.': 'Choose a plan at a glance, then compare every key feature in one clear table.',
  'Основа и чат': 'Core features and chat',
  'Pro-сценарии': 'Pro workflows',
  'GPT-5.6 Luna (авто)': 'GPT-5.6 Luna (automatic)',
  '150 тыс. / неделю · 500 тыс. / месяц': '150K / week · 500K / month',
  '750 тыс. / неделю · 2,5 млн / месяц': '750K / week · 2.5M / month',
  '1,8 млн / неделю · 6,5 млн / месяц': '1.8M / week · 6.5M / month',
  '8 млн / неделю · 30 млн / месяц': '8M / week · 30M / month',
  'Auto: модель, глубина и инструменты': 'Auto: model, reasoning depth, and tools',
  'Расширенный': 'Advanced',
  'Веб‑поиск': 'Web search',
  'Все форматы': 'All formats',
  '* “Без фиксированного лимита” означает, что для функции нет отдельного числового лимита, но остаются общий баланс ИИ, технические ограничения, лимиты размера файлов и защита от злоупотреблений.': '* “No fixed limit” means the feature has no separate numeric allowance. Your shared AI balance, technical constraints, file-size limits, and abuse protection still apply.',
  'Без привязки карты и автосписаний.': 'No card or automatic charges.',
  'Как работает пробный режим?': 'How does the trial work?',
  'Что значит “без фиксированного лимита”?': 'What does “no fixed limit” mean?',
  'Когда спишутся деньги?': 'When will I be charged?',
  'Первое настоящее списание пройдет после окончания пробного периода, если автопродление останется включенным.': 'Your first full charge occurs after the trial ends if auto-renewal remains enabled.',
  'Можно ли отменить до списания?': 'Can I cancel before the first charge?',
  'Что будет, если платеж не пройдет?': 'What happens if the payment fails?',
  'GPT-5.6 Luna в чате с базовым объёмом использования.': 'GPT-5.6 Luna in chat with a basic usage allowance.',
  'Выбор моделей от GPT-5.4 mini до GPT-5.6 Sol.': 'Choose models from GPT-5.4 mini through GPT-5.6 Sol.',
  'Глубина рассуждения до высокой включительно.': 'Reasoning depth up to High.',
  'Все модели, включая GPT-5.6 Sol, Terra и Luna.': 'All models, including GPT-5.6 Sol, Terra, and Luna.',
  'Очень высокая и максимальная глубина, приоритетная скорость.': 'Extra High and Maximum reasoning, with Fast mode.',
  'Максимальный режим': 'Maximum mode',
  'Для интенсивной работы': 'For intensive work',
  '3× лимитов Plus': '3× the Plus allowance',
  'Базовый': 'Basic',
  'Для ежедневной интенсивной работы с сильными моделями: максимальный недельный и месячный объём использования ИИ.': 'For intensive daily work with powerful models: the largest weekly and monthly AI usage allowance.',
  'Максимальный недельный и месячный объём использования ИИ для ежедневной глубокой работы.': 'The largest weekly and monthly AI usage allowance for deep daily work.',
  'Множители относятся к месячному объёму работы ИИ при одинаковых моделях и задачах.': 'Multipliers compare monthly AI allowances for the same models and tasks.',
  'Максимальная глубина рассуждения и Fast-режим.': 'Maximum reasoning depth and Fast mode.',
  'Auto сам выбирает модель, глубину и инструменты под задачу.': 'Auto chooses the model, reasoning depth, and tools for each task.',
  'Веб-поиск для задач, где нужна актуальная информация.': 'Web search for tasks that need current information.',
  'Создание лёгких файлов: Markdown, TXT, CSV и JSON.': 'Create lightweight Markdown, TXT, CSV, and JSON files.',
  'Более глубокий Auto, расширенный tool-calling и длинные задачи.': 'Deeper Auto, expanded tool calling, and longer tasks.',
  'Оформленные PDF, DOCX, XLSX, PPTX, HTML и PNG прямо из чата.': 'Polished PDF, DOCX, XLSX, PPTX, HTML, and PNG files directly from chat.',
  'Все возможности Pro с максимальным бюджетом Auto-задач.': 'Every Pro feature with the largest Auto-task budget.',
  'Все возможности Pro, включая веб-поиск и полный tool-calling.': 'Every Pro feature, including web search and full tool calling.',
  'Генерация изображений GPT Image 2.5: 10 в месяц.': 'GPT Image 2.5 generation: 10 per month.',
  'Генерация изображений GPT Image 2.5: 30 в месяц.': 'GPT Image 2.5 generation: 30 per month.',
  'Генерация изображений GPT Image 2.5: 100 в месяц.': 'GPT Image 2.5 generation: 100 per month.',
  'Генерация изображений GPT Image 2.5': 'GPT Image 2.5 generation',
  'Голос: 600 минут в месяц.': 'Voice: 600 minutes per month.',
  'AI-аналитика: 200 коротких, 60 средних и 20 длинных разборов в месяц.': 'AI analytics: 200 short, 60 medium, and 20 long analyses per month.',
  'Увеличенные лимиты медиа и AI-картинок в дневнике.': 'Higher media and AI image limits in the diary.',
  'Fast-режим': 'Fast mode',
  'Максимальный': 'Maximum',
  '100 / мес': '100 / month',
  '600 мин / мес': '600 min / month',
  '100 фото, 30 видео, 100 файлов / мес': '100 photos, 30 videos, 100 files / month',
  '30 / мес': '30 / month',
  '200 коротких, 60 средних, 20 длинных разборов / мес': '200 short, 60 medium, 20 long analyses / month',
  'Plus, Pro и Max можно попробовать 5 дней.': 'Plus, Pro, and Max include a 5-day trial.',
  'Plus, Pro и Max можно попробовать 5 дней бесплатно.': 'Try Plus, Pro, or Max free for 5 days.',
  'Plus, Pro и Max можно открыть на 5 календарных дней. Если тариф не подходит, автопродление можно отключить в настройках до первого списания.': 'You can try Plus, Pro, or Max for 5 calendar days. If the plan is not right for you, disable auto-renewal in Settings before the first charge.',
  'Тарифы noesa — Free, Plus, Pro и Max': 'noesa plans — Free, Plus, Pro, and Max',
  'noesa — личный ИИ-ассистент, дневник и умный календарь': 'noesa — personal AI assistant, journal, and smart calendar',
  'Личный ИИ-ассистент на русском: дневник с анализом, календарь, трекер привычек и задачи в одном контексте. Начните бесплатно.': 'A personal AI assistant with an analytical journal, calendar, habit tracker, and tasks in one context. Start free.',
  'Личный ИИ-ассистент, который помогает думать, планировать и действовать': 'A personal AI assistant that helps you think, plan, and act',
  'ИИ-планировщик': 'AI planner',
  'ИИ-планировщик и умный календарь — noesa': 'AI planner and smart calendar — noesa',
  'ИИ-планировщик noesa создаёт события и напоминания обычными словами, помогает переносить планы и связывает календарь с дневником, задачами и Telegram.': 'The noesa AI planner creates events and reminders from plain language, helps move plans, and connects your calendar with your journal, tasks, and Telegram.',
  '← На главную noesa': '← Back to noesa home',
  'Все возможности Pro, веб-поиск и полный tool-calling.': 'Every Pro feature, web search, and full tool calling.',
  'Глубокие инсайты доступны в Plus, Pro и Max': 'Deep insights are available on Plus, Pro, and Max.',
  'В Plus, Pro и Max доступны AI-черновики записей, чтобы быстрее фиксировать мысли, замечать важное и не терять ценные наблюдения.': 'AI diary drafts are available on Plus, Pro, and Max, helping you capture thoughts faster and keep important observations.',
  'Скидка за период': 'Billing-period discount',
  'Полгода: 1 месяц бесплатно; год: 2 месяца бесплатно': 'Six months: 1 month free; year: 2 months free',
  'Модель чата': 'Chat model',
  'Выбор моделей': 'Model selection',
  'Месячный объём работы ИИ': 'Monthly AI usage allowance',
  'Глубина рассуждения': 'Reasoning depth',
  'До высокой': 'Up to High',
  'До максимальной': 'Up to Maximum',
  'Приоритетная скорость': 'Priority speed',
  'Как расходуется лимит ИИ?': 'How is my AI allowance used?',
  'Остаток недельного и месячного лимитов показывается в процентах. Расход зависит от модели, сложности задачи, объёма контекста и вызванных инструментов. Более мощные модели и Fast-режим расходуют лимит быстрее. Noesa AI и Noesa Code используют общий баланс.': 'Weekly and monthly balances are shown as percentages. Usage depends on the model, task complexity, context and tools. More powerful models and Fast mode use the allowance faster. Noesa AI and Noesa Code share one balance.',
  'Помочь человеку осознанно управлять своей жизнью': 'Help people take conscious control of their lives',
  'Сценарии внутри': 'Explore the experience',
  'как это работает': 'how it works',
  'Централизованная экосистема noesa для удобного управления своей жизнью': 'One connected noesa ecosystem for managing your life',
  'Платформа на сайте': 'Web platform',
  'Твой путь': 'Your journey',
  'Попробуй прямо сейчас — регистрация занимает 30 секунд.': 'Try it now — creating an account takes 30 seconds.',
  'Понятно': 'Got it',
  'Политика обработки ПД': 'Privacy Policy',
  'Политика обработки персональных данных': 'Privacy Policy',
  'ПД processing policy': 'Privacy Policy',
  'Согласие на обработку ПДн': 'Consent to Personal Data Processing',
  'Согласие на обработку персональных данных': 'Consent to Personal Data Processing'
};

const ENGLISH = {
  ...generatedEnglish,
  ...ENGLISH_OVERRIDES
};

function normalizeLanguage(value) {
  return String(value || '').toLowerCase() === 'en' ? 'en' : 'ru';
}

function inferLanguage() {
  try {
    // Public URLs are stable language editions, independent of browser preferences.
    const route = publicSite.resolvePublicRoute(window.location.pathname);
    if (route) return route.language;
    const stored = localStorage.getItem(LANG_KEY) || localStorage.getItem(LEGACY_LANG_KEY);
    if (SUPPORTED_LANGUAGES.includes(stored)) return stored;
  } catch {}
  try {
    return String(navigator.language || '').toLowerCase().startsWith('ru') ? 'ru' : 'en';
  } catch {
    return 'ru';
  }
}

let activeLanguage = inferLanguage();

function translateCore(value, language) {
  if (!value || language === 'ru') return value;
  if (ENGLISH[value]) return ENGLISH[value];

  const countOf = value.match(/^(\d+)\s+из\s+(\d+)(.*)$/i);
  if (countOf) return `${countOf[1]} of ${countOf[2]}${countOf[3] || ''}`;

  const updated = value.match(/^Обновлено:\s*(.*)$/i);
  if (updated) return `Updated: ${updated[1]}`;

  const trackerCount = value.match(/^(\d+)\s+трекер(?:а|ов)?$/i);
  if (trackerCount) {
    return `${trackerCount[1]} ${Number(trackerCount[1]) === 1 ? 'tracker' : 'trackers'}`;
  }

  const eventCount = value.match(/^(\d+)\s+событи(?:е|я|й)$/i);
  if (eventCount) {
    return `${eventCount[1]} ${Number(eventCount[1]) === 1 ? 'event' : 'events'}`;
  }

  return value;
}

export function tr(value, language = activeLanguage) {
  if (typeof value !== 'string' || !value || language === 'ru') return value;
  const leading = value.match(/^\s*/)?.[0] || '';
  const trailing = value.match(/\s*$/)?.[0] || '';
  const end = value.length - trailing.length;
  const core = value.slice(leading.length, end);
  return `${leading}${translateCore(core, language)}${trailing}`;
}

export function t(key) {
  return tr(key);
}

export function getLang() {
  return activeLanguage;
}

export function getLocale(language = activeLanguage) {
  return language === 'ru' ? 'ru-RU' : 'en-US';
}

function persistLanguage(language) {
  try {
    localStorage.setItem(LANG_KEY, language);
    localStorage.setItem(LEGACY_LANG_KEY, language);
  } catch {}
}

export function setLang(language) {
  activeLanguage = normalizeLanguage(language);
  persistLanguage(activeLanguage);
  try {
    document.documentElement.lang = activeLanguage;
    window.dispatchEvent(new CustomEvent('noesa:language', { detail: activeLanguage }));
  } catch {}
  return activeLanguage;
}

const LocalizationContext = React.createContext({
  language: activeLanguage,
  locale: getLocale(activeLanguage),
  setLanguage: () => {},
  tr
});

const SKIP_SELECTOR = [
  '[data-no-i18n]',
  '[data-user-content]',
  '[contenteditable="true"]',
  'textarea',
  'script',
  'style',
  'pre',
  'code',
  '.ProseMirror',
  '.tiptap',
  '.ql-editor',
  '.cm-content',
  '.chat-markdown',
  '.message-content',
  '.record-content'
].join(',');

const textState = new WeakMap();
const attributeState = new WeakMap();
const TRANSLATABLE_ATTRIBUTES = ['placeholder', 'title', 'aria-label', 'alt'];

function isSkipped(node) {
  const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
  try {
    return Boolean(element?.closest?.(SKIP_SELECTOR));
  } catch {
    return false;
  }
}

function localizeTextNode(node, language) {
  if (!node?.nodeValue || isSkipped(node)) return;
  const current = node.nodeValue;
  let state = textState.get(node);
  if (!state || current !== state.last) {
    const translated = tr(current, 'en');
    if (translated === current) {
      textState.delete(node);
      return;
    }
    state = { source: current, last: current };
    textState.set(node, state);
  }
  const next = language === 'ru' ? state.source : tr(state.source, 'en');
  if (current !== next) {
    state.last = next;
    node.nodeValue = next;
  }
}

function localizeAttributes(element, language) {
  if (!element?.getAttribute || isSkipped(element)) return;
  let states = attributeState.get(element);
  if (!states) {
    states = new Map();
    attributeState.set(element, states);
  }
  for (const name of TRANSLATABLE_ATTRIBUTES) {
    if (!element.hasAttribute(name)) continue;
    const current = element.getAttribute(name) || '';
    let state = states.get(name);
    if (!state || current !== state.last) {
      const translated = tr(current, 'en');
      if (translated === current) {
        states.delete(name);
        continue;
      }
      state = { source: current, last: current };
      states.set(name, state);
    }
    const next = language === 'ru' ? state.source : tr(state.source, 'en');
    if (current !== next) {
      state.last = next;
      element.setAttribute(name, next);
    }
  }
}

function localizeTree(root, language) {
  if (!root || typeof document === 'undefined') return;
  if (root.nodeType === Node.TEXT_NODE) {
    localizeTextNode(root, language);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
  if (root.nodeType === Node.ELEMENT_NODE) localizeAttributes(root, language);
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT
  );
  let current = walker.nextNode();
  while (current) {
    if (current.nodeType === Node.TEXT_NODE) localizeTextNode(current, language);
    else localizeAttributes(current, language);
    current = walker.nextNode();
  }
}

export function I18nProvider({ children }) {
  const [language, setLanguageState] = React.useState(activeLanguage);

  const setLanguage = React.useCallback((nextLanguage) => {
    const next = setLang(nextLanguage);
    setLanguageState(next);
  }, []);

  React.useEffect(() => {
    setLang(language);
    const root = document.body;
    if (!root) return undefined;
    const nativeAlert = window.alert.bind(window);
    const nativeConfirm = window.confirm.bind(window);
    const nativePrompt = window.prompt.bind(window);
    const localizedAlert = (message) => nativeAlert(tr(String(message ?? ''), language));
    const localizedConfirm = (message) => nativeConfirm(tr(String(message ?? ''), language));
    const localizedPrompt = (message, defaultValue) => nativePrompt(
      tr(String(message ?? ''), language),
      defaultValue == null ? defaultValue : tr(String(defaultValue), language)
    );
    window.alert = localizedAlert;
    window.confirm = localizedConfirm;
    window.prompt = localizedPrompt;

    localizeTree(root, language);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          localizeTextNode(mutation.target, language);
          continue;
        }
        for (const node of mutation.addedNodes) localizeTree(node, language);
        if (mutation.type === 'attributes') localizeAttributes(mutation.target, language);
      }
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: TRANSLATABLE_ATTRIBUTES
    });
    return () => {
      observer.disconnect();
      if (window.alert === localizedAlert) window.alert = nativeAlert;
      if (window.confirm === localizedConfirm) window.confirm = nativeConfirm;
      if (window.prompt === localizedPrompt) window.prompt = nativePrompt;
    };
  }, [language]);

  const value = React.useMemo(() => ({
    language,
    locale: getLocale(language),
    setLanguage,
    tr: (value) => tr(value, language)
  }), [language, setLanguage]);

  return React.createElement(
    LocalizationContext.Provider,
    { value },
    React.createElement(React.Fragment, { key: language }, children)
  );
}

export function useI18n() {
  return React.useContext(LocalizationContext);
}
